import { SearchCondition } from "@/types";

export const SET_SEARCH_CONDITION = "SET_SEARCH_CONDITION";

export interface SearchConditionState {
  searchCondition: SearchCondition;
  error: boolean;
}
